import React from 'react'

import './styles.scss'

type Props = {
  children: React.ReactNode
  as?: 'p' | 'div'
  className?: string
}

const ContentBlockText: React.FC<Props> = ({ children, as: Tag = 'p', className }) => {
  const classNames = ['content-block-text', className].filter(Boolean).join(' ')
  return <Tag className={classNames}>{children}</Tag>
}

export default ContentBlockText
